import { render, staticRenderFns } from "./ProtoRightSideTabs.vue?vue&type=template&id=d169c080&scoped=true&"
import script from "./ProtoRightSideTabs.vue?vue&type=script&lang=js&"
export * from "./ProtoRightSideTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProtoRightSideTabs.vue?vue&type=style&index=0&id=d169c080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d169c080",
  null
  
)

export default component.exports